import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React from 'react'
import useRouteParam from '../../hooks/useRouteParam'
import ColumnH1 from '../atoms/columnH1'
import ColumnSideLink from '../atoms/columnSideLink'

const Wrapper = styled.div`
  position: relative;
  border-bottom: solid 2px #e5e5e5;
  margin-bottom: 30px;

  .aside-h1 {
    p {
      border-bottom-width: 2px;
      padding: 0 0 5px;

      &:before {
        display: none;
      }
    }
  }

  .p-list-link {
    position: absolute;
    top: 9px;
    right: 2px;

    &:before {
      display: block;
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: 7px;
      left: -14px;
      border-left: 8px solid #3ec7b3;
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
    }
  }
`

/**
 * コラムサイドバー用リスト型ボタンリンクコンポーネント：新着コラム
 * @constructor
 */
const ColumnSideNewList = (): JSX.Element => {
  const routeParam = useRouteParam('/column/details/C0104/')
  const routeParam2 = useRouteParam('/column/details/C0103/')
  const routeParam3 = useRouteParam('/column/details/C0102/')
  return (
    <Wrapper>
      <ColumnH1 className="aside-h1" label="新着コラム" />
      <Link className="p-list-link" to={useRouteParam('/column/list/')}>
        コラム一覧を表示
      </Link>
      <ColumnSideLink
        href={routeParam}
        label="サービス残業とは？その問題点と対策について解説！"
        date="2026.06.24"
      />
      <ColumnSideLink
        href={routeParam2}
        label="パートタイム・有期雇用労働法の改正について"
        date="2026.06.03"
      />
      <ColumnSideLink
        href={routeParam3}
        label="高年齢者雇用安定法改正について。企業の実務対応策とは？"
        date="2026.04.17"
      />
    </Wrapper>
  )
}

export default ColumnSideNewList
